import { useEffect, useState } from "react";

import {
    Chip,
} from "@mui/material";

import MUIDataTable from "mui-datatables";

import { useNavigate } from "react-router-dom";

import { subscriptionApi } from "../API/subscriptionApi";
import { currentTenant } from "../Common/Credentials";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Menu from "../Component/Menu";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";

export default function SubscriptionList() {

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);

    const loadSubscriptions = async () => {
        try {
            const response =
                await subscriptionApi.getByTenant(currentTenant);

            const data = response.data;
            setRows(
                !data ? [] : Array.isArray(data) ? data : [data]
            );
        } catch (e) {
            // 404 = tenant has no ledger subscription yet - show empty table, no popup
            if (e?.response?.status === 404) setRows([]);
            else setRows([]);
        }
    };

    useEffect(() => {
        loadSubscriptions();
    }, []);

    const columns = [

        {
            name: "id",
            label: "ID",
        },

        {
            name: "tenantId",
            label: "Tenant",
        },

        {
            name: "planName",
            label: "Plan",
        },

        {
            name: "gateway",
            label: "Gateway",
        },

        {
            name: "startDate",
            label: "Start Date",
        },

        {
            name: "expiryDate",
            label: "Expiry Date",
        },

        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (value) => (
                    <Chip
                        label={value}
                        color={
                            value === "ACTIVE"
                                ? "success"
                                : "default"
                        }
                        size="small"
                    />
                ),
            },
        },

        {
            name: "id",
            label: "Actions",
            options: {
                customBodyRender: (value) => (

                    <button
                        className="btn btn-sm hovbuttonColour"
                        onClick={() =>
                            navigate(
                                `/subscriptions/${value}`
                            )
                        }
                    >
                        Manage
                    </button>

                ),
            },
        },
    ];

    const options = {
        filterType: "dropdown",
        selectableRows: "none",
        responsive: "standard",
    };

    return (

        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Subscriptions", path: null }]} />

                            <div className="UI-header-content">
                                <div>
                                    <h1 className="UI-title">
                                        Subscriptions
                                    </h1>
                                    <p className="UI-subtitle">
                                        List of all subscriptions
                                    </p>
                                </div>
                                <div className="UI-header-actions">
                                    <button
                                        className="UI-btn UI-btn-primary"
                                        onClick={() =>
                                            navigate("/subscriptions/create")
                                        }
                                    >
                                        New Subscription
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">

                            <MUIDataTable
                                title=""
                                data={rows}
                                columns={columns}
                                options={options}
                            />

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}